import { BaseURL } from '../../config';

export const FETCH_WIDGET_DATA_API = `${BaseURL}/app/csvupload/widget`;
export const FETCH_CSV_AUTH_TOKEN_API = `${BaseURL}/app/csvupload/authtoken`; // todo this isn't used anywhere
